import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';

function SkipDaysModal({ program, onClose, onSuccess }) {
  const [days, setDays] = useState(1);
  const [isShifting, setIsShifting] = useState(false);
  const [error, setError] = useState(null);

  const handleShiftSchedule = async () => {
    if (days < 1 || days > 365) {
      setError('Please enter a number between 1 and 365');
      return;
    }

    setError(null);
    setIsShifting(true);

    try {
      await workoutAPI.shiftProgramSchedule(program.id, days);
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error shifting schedule:', err);
      setError('Failed to shift schedule. Please try again.');
    } finally {
      setIsShifting(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Skip Days</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p className="mb-3">
          Shift all future workouts forward by a number of days. This is useful if you need to take time off or adjust your schedule.
        </p>

        <Form.Group className="mb-3">
          <Form.Label>Number of Days to Skip</Form.Label>
          <Form.Control
            type="number"
            min="1"
            max="365"
            value={days}
            onChange={(e) => setDays(parseInt(e.target.value) || 1)}
            placeholder="Enter days"
          />
          <Form.Text className="text-muted">
            All future workouts will be pushed forward by this many days
          </Form.Text>
        </Form.Group>

        <Alert variant="info" className="mb-0">
          <i className="fas fa-info-circle me-2"></i>
          <small>
            For example, skipping 7 days means if your next workout was scheduled for tomorrow, it will now be scheduled for next week.
          </small>
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isShifting}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleShiftSchedule} disabled={isShifting}>
          {isShifting ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Shifting...
            </>
          ) : (
            <>
              <i className="fas fa-forward me-2"></i>
              Skip {days} Day{days !== 1 ? 's' : ''}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SkipDaysModal;
